/* Sport Energy — Custom App-Header (JS)
   FASE 1.9.0 (27. august 2026) — vaerktoejerne ud af panelet, genveje ind.
   De stod fremme som en bro VAEK fra sortimentet paa det sted hvor atleten
   er taettest paa at koebe. Samme tool-bridge som blev droppet i
   behovs-boksene. De findes stadig i megamenuen og via intent-kortet, saa
   skriver nogen "svedtest", faar de dem. I stedet fire mekanisme-genveje
   med cf-parametre, og en raekke der starter med Koeb igen.
   FASE 1.8.0 (27. august 2026) — fire ting efter gennemsyn af designet.
   Nul traeffere brugte to kolonner til een linje tekst og efterlod 81 px
   tom plads; panelet er nu een flade der. "Gaa direkte til" gentog
   megamenuen en raekke laengere oppe, saa den er skaaret til de fire
   hovedkategorier og den doede plads under den er vaek. Vaerktoejerne
   kommer fra motoren, saa mobilen viser de samme. Og role="listbox"
   fjernes ved opstart: boernene har aldrig vaeret options, og nu ligger der
   kort og knapper i panelet, saa en skaermlaeser ville annoncere en liste
   uden elementer. Rollen hoerer hjemme i header-blokkens markup og ryddes
   der naar fase 4 bygger den rigtige combobox.
   FASE 1.7.0 (27. august 2026) — soegningen er skilt ud og udvidet.
   Genvejs-tabellen laa kun her, og derfor havde mobilen den ikke (det er
   forklaringen paa at .se-msearch-chip stod i CSS'en uden at nogen kode
   skrev den). Den bor nu i sport-energy-search.js sammen med intent-kortet,
   seneste soegninger, Set for nylig og produktraekken. Denne fil tegner kun
   panelet; motoren er delt med mobil-overlayet.
   Filen loader selv sport-energy-search.js ud fra sin EGEN script-adresse,
   saa hverken header-blokken eller mobil-blokken skal roeres. VIGTIGT: naar
   sport-energy-search.js opdateres, skal SE_SEARCH_V herunder taelles op,
   ellers henter browseren den gamle fra cachen.
   Panelet aabner nu ogsaa paa tomt felt (seneste soegninger, veje ind, Set
   for nylig) og svarer paa nul traeffere med Mente du frem for en blind vej.
   FASE 1.6.0 (27. august 2026) — predictive search: tre rettelser.
   (1) resources[limit] er et SAMLET budget paa tvaers af alle fem
       resource-typer, ikke seks per type. Maalt paa "maurten": limit=6 gav
       2 produkter, 1 kategori, 1 side og 2 forslag. Med limit_scope=each
       giver samme kald 6 produkter og 6 forslag. Hoejre kolonne var altsaa
       halvtom fordi venstre kolonne spiste budgettet.
   (2) Svar der kom i forkert raekkefoelge kunne tegne gamle resultater oven
       paa nye (langsomt foerste kald, hurtigt andet). Hvert kald baerer nu
       et loebenummer og kasseres hvis der er skrevet videre imens.
   (3) Fejlede kaldet, blev de gamle forslag staaende uden signal. Nu en
       rolig linje med vejen videre.
   FASE 1.5.0 (9. august 2026) — dynamisk menu-boks. Boksen i megamenuens
   hoejre soejle fyldes med dagens behov eller dagens nyhed for den kategori,
   panelet daekker. Behovs-boksene kommer fra window.SE_MENU_BOKSE (samme
   metaobjekt som produktgridet), nyheden fra window.SE_MENU_NYE. Dags-
   rotationen er forskudt +1 ift. gridet, saa man ikke moeder samme boks to
   gange paa vej fra menu til kollektion. Nyheds-pladsen deltager kun naar
   kategorien faktisk har et produkt publiceret inden for 30 dage — samme
   vindue som Ny-maerket. Uden data roeres boksen ikke, og den statiske
   fallback fra Liquid-blokken bliver staaende.
   FASE 1.4.0 (9. august 2026) — scroll-hak ved kondensering fjernet.
   Reserveret plads under den fixed header (body padding-top) skiftede foer
   vaerdi samtidig med kondenseringen (164 -> 108). Fordi headeren er ude af
   flow, flyttede det hele dokumentet, mens scroll-offset stod stille, og
   siden "sprang" et par cm. CSS'en holder nu pladsen konstant paa 165 px;
   headeren kondenserer kun visuelt til 110 px og indholdet glider ind under
   den. Taersklerne herunder er bundet til den geometri.
   BEMAERK: denne fil indeholder leverings-modulets runtime (FASE 1.3.0).
   Deploy aldrig en aeldre kopi henover den.
   FASE 1.3.0 (22. juli 2026) — permanent leverings-modul: bygger og styrer
   leverings-kortet (window.SE_LEVERING). Valgfri midlertidig besked med
   valgfri slutdato (client-side — Liquid er cached). Popup appendes til
   body; window.seLeveringOpen deles med mobil-nav-JS.
   FASE 1.2.3 (22. juli 2026) — ferie-runtime fjernet (rollback efter ferien).
   FASE 1.2.2 (13. juli 2026) — een samlet leverings-linje: den normale
   skjules via hidden (virker nu, jf. CSS 1.2.1) og ferie-linjen baerer
   baade ferie og leveringstid. barLev-swap udgaaet.
   FASE 1.2.1 (13. juli 2026) — leverings-linjen faar barLev-tekst (3–4 dage)
   i stedet for hidden (hidden tabte til .se-usp-l span display-reglen —
   begge linjer stod synlige live). Tekst-noden swappes, svg-ikonet bevares.
   FASE 1.2.0 (13. juli 2026) — midlertidig ferie-besked: swapper leverings-
   linjen til klikbar ferie-linje naar window.SE_FERIE.active og foer slutdato
   (client-side kill-switch — Liquid er cached). Popup bygges i JS og
   appendes til body; window.seFerieOpen deles med mobil-nav-JS.
   FASE 1.1.0 (2. juli 2026) — delt cart-watcher-register (window.__seCartWatchers):
   fetch wrappes kun én gang på tværs af header- og mobil-JS, så læg-i-kurv ikke
   udløser dobbelt cart.js-kald når begge kører.
   FASE 1.0.0 — udskilt fra Custom Liquid-blok til asset-fil.
   Routes leveres via window.SEHeader (sat i Liquid-blokken før denne
   fil loades), da asset-JS ikke kan rendere Liquid. */

// Loader den delte soege-motor. Adressen udledes af denne fils egen src, saa
// den ligger i samme assets-mappe. Versionen haenger paa som query, fordi
// Shopify ellers serverer en cachet kopi naar kun search-filen er skiftet.
(function motor(){
  if(window.SESearch || window.__seSearchIndlaeses) return;
  var SE_SEARCH_V = '2.1.0';
  var mig = document.currentScript ||
    document.querySelector('script[src*="sport-energy-header.js"]');
  if(!mig || !mig.src) return;
  window.__seSearchIndlaeses = true;
  var el = document.createElement('script');
  el.src = mig.src.split('?')[0].replace('sport-energy-header.js','sport-energy-search.js')
    + '?v=' + SE_SEARCH_V;
  document.head.appendChild(el);
})();

(function(){
  var cfg = (window.SEHeader||{search_url:'/search',predictive_search_url:'/search/suggest',cart_url:'/cart'});
  cfg = {searchUrl:cfg.search_url, predictiveUrl:cfg.predictive_search_url, cartUrl:cfg.cart_url};
  var root = document.querySelector('.se-head'); if(!root) return;

  var wrap  = document.getElementById('se-search');
  var input = document.getElementById('se-search-input');
  var pred  = document.getElementById('se-pred');
  var goBtn = document.getElementById('se-search-go');
  var t, lastQ='', seq=0;
  // Panelet er markeret role="listbox" i header-blokken, men boernene har
  // aldrig vaeret role="option", og nu ligger der ogsaa kort og knapper i
  // det. En skaermlaeser vil melde en liste uden elementer. Indtil fase 4
  // bygger det rigtige combobox-moenster, er ingen rolle mere aerlig end en
  // forkert. aria-label bliver staaende.
  if(pred && pred.getAttribute('role')==='listbox') pred.removeAttribute('role');

  function money(kr){ return kr.toLocaleString('da-DK',{minimumFractionDigits:0,maximumFractionDigits:2})+' kr.'; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]; }); }
  function submitSearch(){
    var q=input.value.trim(); if(!q) return;
    if(window.SESearch) window.SESearch.husk(q);
    window.location.href=cfg.searchUrl+'?q='+encodeURIComponent(q);
  }
  if(goBtn) goBtn.addEventListener('click', submitSearch);

  // Query-highlighting: fremhæv det man skriver i et forslag.
  function highlight(text, q){
    var s=esc(text); if(!q) return s;
    var i=text.toLowerCase().indexOf(q.toLowerCase());
    if(i<0) return s;
    return esc(text.slice(0,i))+'<b class="hlq">'+esc(text.slice(i,i+q.length))+'</b>'+esc(text.slice(i+q.length));
  }

  // Genveje, intent og raekken kommer fra den delte motor. Er den ikke
  // naaet at loade endnu, tegner panelet bare uden dem og bliver tegnet om
  // naar se:search-ready falder.
  function motor(){ return window.SESearch || null; }
  function matchShortcuts(q){ var m=motor(); return m ? m.chips(q) : []; }

  // Veje ind naar feltet er tomt. Ligger her frem for i motoren, fordi det er
  // butikkens egne kategorier og ikke generel soegelogik.
  // Seks, ikke fire. Jeg skar den til fire for at fjerne den doede plads
  // under kolonnen, og maalte bagefter at hullet VOKSEDE fra 89 til 156 px:
  // hoejden saettes af venstre kolonne, saa faerre links giver mere tomhed.
  // Flasker og Vejledninger staar desuden ikke i megamenuens hovedraekke.
  var VEJE_IND = [
    { t:'Energi',        u:'/collections/energi-gels-barer-drikke' },
    { t:'Hydrering',     u:'/collections/hydrering-elektrolytter-sportsdrikke' },
    { t:'Protein',       u:'/collections/protein-produkter' },
    { t:'Sportstilskud', u:'/collections/sportstilskud-til-restitution-praestation' },
    { t:'Flasker',       u:'/collections/flasker-sportsflasker-shakers' },
    { t:'Vejledninger',  u:'/pages/vejledninger' }
  ];
  var PIL_H = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';

  function chipHTML(sc){
    return '<a class="se-pred-chip" href="'+esc(sc.url)+'"><span class="ci"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'+(sc.ikon||sc.icon||'')+'</svg></span>'+esc(sc.label)+'</a>';
  }

  // Raekken tegnes efter panelet, fordi den kan kraeve et opslag. Loebenummeret
  // sikrer at et langsomt svar ikke lander i et panel der er skiftet imens.
  var sidsteSig='';
  function tegnRaekke(q, antal, mit){
    var m=motor(); if(!m) return;
    m.raekke(q, antal, function(titel, liste){
      if(mit!==seq || !titel || !liste || !liste.length) return;
      var grid=pred.querySelector('.se-pred-grid') || pred.querySelector('.se-pred-solo');
      if(!grid) return;
      // Er raekken den samme som den der staar, saa lad den staa. Ellers ville
      // kortene spille deres fjeder forfra ved hvert tastetryk.
      var sig=titel+'|'+liste.map(function(x){ return x.handle; }).join(',');
      var gammel=pred.querySelector('.se-sr-row');
      if(gammel && gammel.getAttribute('data-sig')===sig) return;
      if(gammel) gammel.parentNode.removeChild(gammel);
      grid.insertAdjacentHTML('afterend', m.raekkeHTML(titel, liste, 'se-sr'));
      var ny=pred.querySelector('.se-sr-row');
      if(ny){
        ny.setAttribute('data-sig', sig);
        // Panelet tegnes helt om ved hvert tastetryk, saa raekken foedes paa ny
        // selv naar indholdet er det samme. Er det de samme produkter som sidst,
        // springer vi fjederen over: den skal spille naar noget SKIFTER, ikke
        // mens man skriver videre paa et ord der ikke findes.
        if(sig===sidsteSig) ny.classList.add('is-rolig');
        sidsteSig=sig;
      }
      m.bind(pred);
    });
  }

  // Tomt felt: ingen soegning at vaere relateret til endnu. Venstre kolonne er
  // atletens egen historik, hoejre er vejene ind, og raekken baerer produkterne.
  function tegnTom(){
    var m=motor();
    var sen=(m?m.seneste():[]).slice(0,4);
    var left='<div class="se-pred-left">';
    if(sen.length){
      left+='<div class="se-pred-sect"><div class="se-pred-head">Seneste søgninger</div>';
      sen.forEach(function(x){
        left+='<a class="se-pred-sugg" href="'+esc(cfg.searchUrl)+'?q='+encodeURIComponent(x)+'">'+esc(x)+'</a>';
      });
      left+='</div>';
    }
    left+='<div class="se-pred-sect"><div class="se-pred-head">Genveje</div>';
    (m?m.standardChips():[]).forEach(function(v){ left+=chipHTML(v); });
    left+='</div></div>';
    var right='<div class="se-pred-right"><div class="se-pred-head">Gå direkte til</div>';
    VEJE_IND.forEach(function(v){
      right+='<a class="se-pred-link" href="'+esc(v.u)+'"><span class="t">'+esc(v.t)+'</span>'+PIL_H+'</a>';
    });
    right+='</div>';
    pred.innerHTML='<div class="se-pred-grid">'+left+right+'</div>';
    wrap.classList.add('open');
    tegnRaekke('', 0, seq);
  }

  function render(data, q){
    var prods=data.products||[], colls=data.collections||[], pages=data.pages||[], arts=data.articles||[], qs=data.queries||[];
    var shortcuts=matchShortcuts(q);
    var m=motor();
    var it=m?m.intent(q):null;
    var tomt=!prods.length && !colls.length && !pages.length && !arts.length;
    // Nul traeffere: een flade. To kolonner til een linje tekst efterlod
    // 81 px tom plads, og raekken er alligevel svaret her.
    if(tomt){
      var solo='<div class="se-pred-solo">';
      if(it && it.mente){
        solo+='<div class="se-pred-empty"><b>Ingen produkter hedder '+esc(q)+'</b>Vi tror du mener '+esc(it.mente)+'. De nærmeste står herunder.</div>'
          +'<a class="se-pred-solo-link" href="'+esc(cfg.searchUrl)+'?q='+encodeURIComponent(it.soeg||it.mente)+'">Søg efter '+esc(it.mente)+'</a>';
      } else {
        solo+='<div class="se-pred-empty"><b>Ingen produkter matcher '+esc(q)+'</b>Prøv et andet ord, eller se hvad du sidst kiggede på.</div>';
      }
      if(shortcuts.length){
        solo+='<div class="se-pred-solo-chips">';
        shortcuts.forEach(function(sc){ solo+=chipHTML(sc); });
        solo+='</div>';
      }
      solo+='</div>';
      pred.innerHTML=solo;
      wrap.classList.add('open');
      tegnRaekke(q, 0, seq);
      return;
    }
    var left='<div class="se-pred-left">';
    // Søgeforslag (query suggestions)
    if(qs.length){
      left+='<div class="se-pred-sect"><div class="se-pred-head">Forslag</div>';
      qs.slice(0,5).forEach(function(s){
        left+='<a class="se-pred-sugg" href="'+esc(cfg.searchUrl)+'?q='+encodeURIComponent(s.text||s)+'">'+highlight(s.text||s,q)+'</a>';
      });
      left+='</div>';
    }
    // Mekanisme-genveje
    if(shortcuts.length){
      left+='<div class="se-pred-sect"><div class="se-pred-head">Filtrér direkte</div>';
      shortcuts.forEach(function(sc){
        left+=chipHTML(sc);
      });
      left+='</div>';
    }
    // Kategorier
    if(colls.length){
      left+='<div class="se-pred-sect"><div class="se-pred-head">Kategorier</div>';
      colls.slice(0,4).forEach(function(c){
        left+='<a class="se-pred-link" href="'+esc(c.url)+'"><span class="t">'+highlight(c.title,q)+'</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg></a>';
      });
      left+='</div>';
    }
    // Sider + guides (artikler)
    var sidePages=pages.concat(arts);
    if(sidePages.length){
      left+='<div class="se-pred-sect"><div class="se-pred-head">Sider og guides</div>';
      sidePages.slice(0,4).forEach(function(p){
        left+='<a class="se-pred-sugg" href="'+esc(p.url)+'">'+highlight(p.title,q)+'</a>';
      });
      left+='</div>';
    }
    left+='</div>';

    // Højre: produkter
    // Overskriften "Produkter" giver kun mening naar der ER produkter.
    var right='<div class="se-pred-right">'+(prods.length?'<div class="se-pred-head">Produkter</div>':'');
    if(prods.length){
      prods.slice(0,6).forEach(function(p){
        var img=p.image?'<img class="se-pred-thumb" src="'+esc(p.image)+'&width=92" alt="" loading="lazy">':'<span class="se-pred-thumb"></span>';
        var price=(p.price!=null)?'<span class="se-pred-price">'+money(p.price)+'</span>':'';
        var meta=p.meta?'<span class="se-pred-meta">'+esc(p.meta)+'</span>':'';
        right+='<a class="se-pred-item" href="'+esc(p.url)+'">'+img+'<span class="se-pred-body"><span class="se-pred-name">'+highlight(p.title,q)+'</span>'+meta+'</span>'+price+'</a>';
      });
    }
    right+='</div>';

    var fod = prods.length
      ? '<a class="se-pred-foot" href="'+esc(cfg.searchUrl)+'?q='+encodeURIComponent(q)+'">Se alle resultater for '+esc(q)+'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>'
      : '';
    pred.innerHTML='<div class="se-pred-grid">'+left+right+'</div>'+fod;
    wrap.classList.add('open');
    tegnRaekke(q, prods.length, seq);
  }

  function search(q){
    // limit_scope=each: uden den er 6 et samlet loft for ALLE typer tilsammen,
    // og produkterne bliver klemt ned til to. Verificeret mod live.
    var url=cfg.predictiveUrl+'?q='+encodeURIComponent(q)
      +'&resources[type]=product,collection,page,article,query'
      +'&resources[limit]=6&resources[limit_scope]=each'
      +'&resources[options][unavailable_products]=last';
    // Loebenummer: kun det NYESTE kald maa tegne. Uden det kan et langsomt
    // svar paa "mau" lande efter "maurten" og overskrive de rigtige forslag.
    var mit=++seq;
    fetch(url,{headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(mit!==seq) return;
        var r=(d.resources&&d.resources.results)||{};
        // Predictive search leverer pris som streng i KRONER (fx "25.00"
        // eller "25,00"), ikke øre. Parse som float, ikke parseInt/100.
        function toKr(x){ if(x==null) return null; var n=parseFloat(String(x).replace(',','.')); return isNaN(n)?null:n; }
        // Kollektions-titler har form "Energi | undertitel" — vis kun
        // kategorinavnet før |, som filteret gør på kollektionssiderne.
        function shortTitle(t){ return String(t||'').split('|')[0].trim(); }
        render({
          products:(r.products||[]).map(function(p){
            var v=(p.variants&&p.variants[0])||null;
            // Produkt-titler har form "Maurten Gel 160 | Neutral" — vis
            // navnet før | som titel, delen efter | (smag/variant) som meta.
            var parts=String(p.title||'').split('|');
            var name=parts[0].trim();
            var flavour=parts.length>1?parts.slice(1).join('|').trim():'';
            var meta=flavour||p.vendor||(v&&v.title&&v.title!=='Default Title'?v.title:'');
            return {title:name,url:p.url,meta:meta,
              image:(p.featured_image&&p.featured_image.url)||p.image||null,
              price:(p.price!=null)?toKr(p.price):(v&&v.price!=null?toKr(v.price):null)};
          }),
          collections:(r.collections||[]).map(function(c){ return {title:shortTitle(c.title),url:c.url}; }),
          pages:(r.pages||[]).map(function(p){ return {title:shortTitle(p.title),url:p.url}; }),
          articles:(r.articles||[]).map(function(a){ return {title:shortTitle(a.title),url:a.url}; }),
          queries:(r.queries||[]).map(function(qq){ return {text:qq.text||qq.styled_text||qq}; })
        }, q);
      }).catch(function(){
        if(mit!==seq) return;
        pred.innerHTML='<div class="se-pred-empty">Kunne ikke hente forslag lige nu. Tryk Enter for at søge i hele butikken.</div>';
        wrap.classList.add('open');
      });
  }
  if(input){
    input.addEventListener('input', function(){
      var q=input.value.trim(); clearTimeout(t);
      if(q.length<2){ seq++; lastQ=''; tegnTom(); return; }
      if(q===lastQ) return; lastQ=q;
      t=setTimeout(function(){ search(q); }, 160);
    });
    input.addEventListener('keydown', function(e){
      if(e.key==='Enter'){ submitSearch(); return; }
      if(e.key==='Escape'){ wrap.classList.remove('open'); input.blur(); return; }
      // Pil-navigation gennem forslag
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
        var links=pred.querySelectorAll('a'); if(!links.length) return;
        e.preventDefault();
        var cur=document.activeElement, idx=-1;
        for(var i=0;i<links.length;i++){ if(links[i]===cur){ idx=i; break; } }
        idx=(e.key==='ArrowDown')?Math.min(idx+1,links.length-1):Math.max(idx-1,0);
        links[idx].focus();
      }
    });
    // Fokus paa tomt felt aabner panelet i stedet for at lade det staa doedt.
    input.addEventListener('focus', function(){
      var q=input.value.trim();
      if(q.length>=2){ if(pred.innerHTML) wrap.classList.add('open'); return; }
      tegnTom();
    });
    // Motoren kan naa frem efter foerste tegning; tegn om saa raekken kommer med.
    document.addEventListener('se:search-ready', function(){
      if(!wrap.classList.contains('open')) return;
      var q=input.value.trim();
      if(q.length<2) tegnTom();
    });
  }
  document.addEventListener('click', function(e){ if(!wrap.contains(e.target)) wrap.classList.remove('open'); });

  // ── Konto-dropdown ──────────────────────────────────────────────────
  // Åbner på klik (bevidst, virker på touch), lukker ved klik udenfor eller
  // Escape. aria-expanded holdes i sync. Selve login/opret sker på Shopifys
  // egne sider (kan ikke indlejres sikkert) — dropdownen er en rolig indgang.
  var acct = document.getElementById('se-acct');
  if(acct){
    var acctBtn = document.getElementById('se-acct-btn');
    function closeAcct(){ acct.classList.remove('is-open'); if(acctBtn){ acctBtn.classList.remove('se-acct-open'); acctBtn.setAttribute('aria-expanded','false'); } }
    function toggleAcct(){
      var open = acct.classList.toggle('is-open');
      if(acctBtn){ acctBtn.classList.toggle('se-acct-open', open); acctBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    }
    acctBtn.addEventListener('click', function(e){ e.stopPropagation(); toggleAcct(); });
    document.addEventListener('click', function(e){ if(!acct.contains(e.target)) closeAcct(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeAcct(); });
  }

  var badge=document.getElementById('se-cart-count');
  function setCount(n){ if(!badge) return; badge.textContent=n; if(n>0){ badge.hidden=false; badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); } else { badge.hidden=true; } }
  function refreshCart(){ fetch(cfg.cartUrl+'.js',{headers:{'Accept':'application/json'} }).then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count); }).catch(function(){}); }
  function isCartWrite(u){ if(typeof u!=='string') return false; return u.indexOf('/cart/add')>=0||u.indexOf('/cart/change')>=0||u.indexOf('/cart/update')>=0||u.indexOf('/cart/clear')>=0; }
  // Delt watcher-register: fetch wrappes kun ÉN gang på tværs af header- og
  // mobil-JS (begge kan køre). Ellers udløser hvert læg-i-kurv to cart.js-kald.
  if(!window.__seCartWatchers){
    window.__seCartWatchers=[];
    var _fetch=window.fetch;
    window.fetch=function(){ var a=arguments,u=(a[0]&&a[0].url)||a[0]||''; return _fetch.apply(this,a).then(function(res){ if(isCartWrite(u)){ for(var i=0;i<window.__seCartWatchers.length;i++) window.__seCartWatchers[i](); } return res; }); };
  }
  window.__seCartWatchers.push(refreshCart);
  document.addEventListener('submit', function(e){ if(e.target&&e.target.action&&String(e.target.action).indexOf('/cart/add')>=0) setTimeout(refreshCart,400); }, true);
  ['cart:updated','cart:refresh','kaching:cart:updated'].forEach(function(ev){ document.addEventListener(ev, refreshCart); });

  // ── Scroll-kondensering ─────────────────────────────────────────────
  // Headeren trækker sig sammen når man scroller ned forbi en tærskel, og
  // folder ud igen nær toppen. Hysterese (to tærskler) forhindrer flimmer
  // ved grænsen. rAF-throttling holder scroll-handleren billig. Al visuel
  // bevægelse sker i CSS via klassen .is-condensed — JS toggler kun den.
  // Taersklerne er bundet til geometrien: reserveret plads 165 px, kondenseret
  // header 110 px → kondensering er foerst sikker ved y > 55. Under det ville
  // indholdets top ligge under headerens underkant og efterlade en stribe.
  var CONDENSE_AT = 120;  // scroll ned forbi denne → kondensér
  var EXPAND_AT   = 70;   // scroll op forbi denne → fold ud
  var condensed = false;
  var ticking = false;
  var body = document.body;
  // Skub sideindholdet ned under den fixed header (padding-top på body).
  // Sættes med JS så siden stadig virker hvis CSS'en loader men JS ikke gør
  // (så ligger headeren blot øverst uden padding — bedre end dobbelt padding).
  body.classList.add('se-has-fixed-header');
  function setCondensed(on){
    condensed = on;
    if(on){ root.classList.add('is-condensed'); body.classList.add('se-condensed'); }
    else  { root.classList.remove('is-condensed'); body.classList.remove('se-condensed'); }
  }
  function onScroll(){
    if(ticking) return;
    ticking = true;
    (window.requestAnimationFrame || function(cb){ setTimeout(cb,16); })(function(){
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if(!condensed && y > CONDENSE_AT) setCondensed(true);
      else if(condensed && y < EXPAND_AT) setCondensed(false);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // sæt korrekt tilstand ved load (fx hvis siden åbnes midt-scroll)



  // ── Dynamisk menu-boks (FASE 1.5.0) ───────────────────────────────
  // Kun bokse med data-kat roeres; Vaerktoejer-panelet har ingen og beholder
  // sit faste indhold. Alt udvaelgelse er klientside, fordi Liquid er cached.
  (function menuBoks(){
    var slots = document.querySelectorAll('.se-feat[data-kat]');
    if(!slots.length) return;
    var NY_DAGE = 30;
    var PIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

    // Titler har form "Navn | smag" — navnet foran, smagen som meta.
    function navnDel(t){ return String(t == null ? '' : t).split('|')[0].trim(); }
    function smagDel(t){
      var d = String(t == null ? '' : t).split('|');
      return d.length > 1 ? d.slice(1).join('|').trim() : '';
    }

    // Behovs-boksene sorteres paa metaobjekt-handlet, saa rotationen staar
    // fast paa tvaers af page-loads uanset hvilken raekkefoelge Liquid gav.
    function behovFor(kat){
      var b = (window.SE_MENU_BOKSE || {})[kat] || [];
      return b.slice().sort(function(x, y){
        var a = String(x.s || ''), c = String(y.s || '');
        return a < c ? -1 : (a > c ? 1 : 0);
      });
    }
    // Nyeste produkt i kategorien, men kun hvis det er inden for vinduet.
    // Er der ingen, falder pladsen bare vaek og der roteres paa behovene.
    function nyesteFor(kat){
      var liste = window.SE_MENU_NYE || [], bedst = null;
      var graense = (Date.now() / 1000) - (NY_DAGE * 86400);
      for(var i = 0; i < liste.length; i++){
        var p = liste[i];
        if(!p || !p.k || String(p.k).indexOf(kat) < 0) continue;
        if(!(p.ts > graense)) continue;
        if(!bedst || p.ts > bedst.ts) bedst = p;
      }
      return bedst;
    }
    // Behovs-boksens link er enten cf-parametre eller en direkte URL. I
    // menuen staar vi IKKE paa kollektionen endnu, saa cf-parametrene skal
    // haenge paa kollektionens egen adresse — ikke bare '?'.
    //
    // VIGTIGT: vaerdierne SKAL kodes, ikke haenges raa paa. Et '+' i en raa
    // query-streng laeses af URLSearchParams som et mellemrum, saa filterets
    // "25 g+" bliver til "25 g " og rammer nul produkter. Verificeret live:
    // ?cf_protein=25%20g+ giver 0 kort, ?cf_protein=25%20g%2B giver 5.
    // Samme gaelder '&' inde i en vaerdi: ?cf_formal=Soevn & Restitution
    // giver 0 kort, %26-kodet giver 9.
    function behovUrl(kat, cf){
      var v = String(cf || '');
      if(!v) return '/collections/' + kat;
      if(v.charAt(0) === '/' || v.indexOf('http') === 0) return v;
      // Parametre adskilles paa '&cf_', ikke paa '&' alene: flere
      // facet-vaerdier indeholder selv et 'og' ("Soevn & Restitution"), og
      // et raat '&' der ville dele strengen midt i vaerdien. Alle noegler er
      // cf-praefikset, saa '&cf_' er et sikkert skel.
      var dele = [], start = 0, i;
      for(i = 1; i < v.length; i++){
        if(v.charAt(i) === '&' && v.slice(i + 1, i + 4) === 'cf_'){
          dele.push(v.slice(start, i));
          start = i + 1;
        }
      }
      dele.push(v.slice(start));
      var ud = [];
      for(i = 0; i < dele.length; i++){
        var d = dele[i];
        if(!d) continue;
        var lig = d.indexOf('=');
        if(lig < 0){ ud.push(encodeURIComponent(d)); continue; }
        ud.push(encodeURIComponent(d.slice(0, lig)) + '=' + encodeURIComponent(d.slice(lig + 1)));
      }
      return '/collections/' + kat + '?' + ud.join('&');
    }

    for(var i = 0; i < slots.length; i++){
      (function(el){
        var kat = el.getAttribute('data-kat');
        var valg = behovFor(kat);
        var nyt = nyesteFor(kat);
        if(nyt) valg = valg.concat([{ nyhed: nyt }]);
        if(!valg.length) return;                     // ingen data → behold fallback

        // Dags-rotation som forsidens hero. +1 forskyder mod produktgridet,
        // saa menuen og kollektionen ikke viser den samme boks samme dag.
        var dag = Math.floor(Date.now() / 86400000) + 1;
        var v = valg[dag % valg.length];
        var html;

        if(v.nyhed){
          var p = v.nyhed;
          var smag = smagDel(p.t);
          var pris = '<b>' + money(p.p / 100) + '</b>';
          var flise = '<span class="se-fd-tile"><span class="se-fd-ny">Ny</span>'
            + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '') + '</span>';
          html = '<a class="se-fd" href="' + esc(p.u) + '">' + flise
            + '<span class="se-fd-k">Nyt på hylden</span>'
            + '<span class="se-fd-t">' + esc(navnDel(p.t)) + '<span class="m">.</span></span>'
            + '<span class="se-fd-m">' + (smag ? esc(smag) + ' · ' + pris : pris) + '</span>'
            + '<span class="se-fd-cta">Se produktet' + PIL + '</span></a>';
          el.classList.add('no-img');
          el.style.backgroundImage = '';
        } else {
          html = '<a class="se-fd" href="' + esc(behovUrl(kat, v.cf)) + '">'
            + (v.ey ? '<span class="se-fd-k">' + esc(v.ey) + '</span>' : '')
            + '<span class="se-fd-t">' + esc(v.ti) + '<span class="m">.</span></span>'
            + (v.tx ? '<span class="se-fd-b">' + esc(v.tx) + '</span>' : '')
            + '<span class="se-fd-cta">' + esc(v.ct || 'Se dem her') + PIL + '</span></a>';
          if(v.bg){ el.style.backgroundImage = 'url("' + v.bg + '")'; el.classList.remove('no-img'); }
          else { el.classList.add('no-img'); }
        }
        el.innerHTML = html;
        el.classList.add('is-dyn');
      })(slots[i]);
    }
  })();

  // ── Leverings-modul (permanent, FASE 1.3.0) ───────────────────────
  // Klikbar leverings-linje i USP-baren. Kortets indhold og en valgfri
  // midlertidig besked styres fra window.SE_LEVERING i Custom Liquid-blokken.
  // Besked-slutdato haandteres her (client-side — server-Liquid er cached).
  (function levering(){
    var cfg = window.SE_LEVERING;
    var btn = document.getElementById('se-lev-btn');
    if(!cfg || !btn) return;
    var u = btn.querySelector('u'); if(u && cfg.bar) u.textContent = cfg.bar;

    function beskedAktiv(){
      var b = cfg.besked;
      if(!b || !b.active || !b.tekst) return false;
      if(b.slut && Date.now() >= new Date(b.slut).getTime()) return false;
      return true;
    }
    var lastFocus = null;
    function build(){
      var ovl = document.getElementById('se-lp-ovl');
      if(ovl) return ovl;
      ovl = document.createElement('div');
      ovl.id = 'se-lp-ovl'; ovl.className = 'se-lp-ovl'; ovl.hidden = true;
      var rows = '';
      var i;
      for(i = 0; i < cfg.raekker.length; i++){
        rows += '<div class="se-lp-row"><span class="se-lp-key"></span><span class="se-lp-val"></span></div>';
      }
      ovl.innerHTML =
        '<div class="se-lp-card" role="dialog" aria-modal="true" tabindex="-1">'
        + '<button class="se-lp-x" type="button" aria-label="Luk"><svg viewBox="0 0 24 24"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>'
        + '<div class="se-lp-k"></div>'
        + '<h3></h3>'
        + '<div class="se-lp-rows">' + rows + '</div>'
        + '<div class="se-lp-besked" hidden><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><line x1="12" y1="10.5" x2="12" y2="16"/><line x1="12" y1="7.5" x2="12" y2="7.6"/></svg><span></span></div>'
        + '<a class="se-lp-retur" href="#"></a>'
        + '<button class="se-lp-ok" type="button"></button>'
        + '</div>';
      document.body.appendChild(ovl);
      var card = ovl.querySelector('.se-lp-card');
      card.setAttribute('aria-label', cfg.titel);
      ovl.querySelector('.se-lp-k').textContent = cfg.eyebrow;
      ovl.querySelector('h3').textContent = cfg.titel;
      var keys = ovl.querySelectorAll('.se-lp-key');
      var vals = ovl.querySelectorAll('.se-lp-val');
      for(i = 0; i < cfg.raekker.length; i++){
        keys[i].textContent = cfg.raekker[i][0];
        vals[i].textContent = cfg.raekker[i][1];
      }
      var ret = ovl.querySelector('.se-lp-retur');
      if(cfg.returUrl && cfg.returTekst){
        ret.href = cfg.returUrl; ret.textContent = cfg.returTekst;
      } else {
        ret.hidden = true;
      }
      ovl.querySelector('.se-lp-ok').textContent = cfg.knap;
      function close(){
        ovl.classList.remove('is-open');
        setTimeout(function(){ ovl.hidden = true; }, 280);
        if(lastFocus && lastFocus.focus) lastFocus.focus();
      }
      ovl.addEventListener('click', function(e){ if(e.target === ovl) close(); });
      ovl.querySelector('.se-lp-x').addEventListener('click', close);
      ovl.querySelector('.se-lp-ok').addEventListener('click', close);
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && !ovl.hidden) close();
      });
      return ovl;
    }
    window.seLeveringOpen = function(from){
      lastFocus = from || document.activeElement;
      var ovl = build();
      var box = ovl.querySelector('.se-lp-besked');
      if(beskedAktiv()){
        box.querySelector('span').textContent = cfg.besked.tekst;
        box.hidden = false;
      } else {
        box.hidden = true;
      }
      ovl.hidden = false;
      requestAnimationFrame(function(){ ovl.classList.add('is-open'); });
      ovl.querySelector('.se-lp-card').focus();
    };
    btn.addEventListener('click', function(){ window.seLeveringOpen(btn); });
  })();

})();